import { Injectable } from '@angular/core';
import { TransactionTypes } from '@lib/constants/transaction.constant';
import { PermissionService } from '@lib/services/permission.service';

@Injectable({
    providedIn: 'root',
})
export class Utils {
    constructor(private permissionService: PermissionService) {}

    getTransactionType(txnType: string): string {
        if (txnType === '') return 'N/A';
        return TransactionTypes[txnType as keyof typeof TransactionTypes];
    }

    getPermissions(permissionName: string): boolean {
        const allPermissions = this.permissionService.getPermissions();
        if (allPermissions && allPermissions.some((permission) => permission === permissionName)) {
            return true;
        } else {
            return false;
        }
    }

    getCurrencyByTenantName(currency: any[], tenantName?: string) {
        if (!tenantName) {
            return currency;
        }

        return currency.filter(curr => !curr.renderTenants || curr.renderTenants.includes(tenantName));
    }

    downloadFile(data: Blob) {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
    }

    base64ToBlob(base64: string, contentType: string): Blob {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
}
